import { ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'
import { replaceRouteParams } from '../../helpers/url'

// PLOP_APPEND_PATTERN_ANCHOR

export function updateUserService(userData, userId) {
  return madeRequest('PATCH', {
    data: userData,
    url: replaceRouteParams(ENDPOINTS.userSpecific, {
      id: userId
    })
  })
}
